import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';
import historyHandler from 'jd-library/historyHandler';
import FormGroup from 'jd-library/FormGroup';
import FormFeedBack from 'jd-library/FormFeedBack';
import FormLabel from 'jd-library/FormLabel';
import InputGroup from 'jd-library/InputGroup';
import Button from 'jd-library/Button';
import axios from 'axios';
import {setLoggedUser} from '../../actions/index';
import {setAuditObject} from '../../actions/products';
import {fetchAuditUrl,logOut} from '../../utills';
import {auditorDomain} from '../../../config/config'; 
import OtpVerification from 'jd-library/OtpVerification'
import "./audit_enrich_login.scss";


const sendOtp = (options = {}) => {
	let { userName, companyName, cb, token} = options;
	let type = 'mobile';
	if(isNaN(userName)) {
		type = 'email';
	}
	axios.get(`/vendor/manage-products-genio/${token}/api/sendOtp.ns?userName=${userName}&isAuditor=${true}&type=${type}`).then((data) => {
		cb && cb(data);
	});
};

const verifyOtp = (options = {}) => {
	let {otp, cb, token} = options;
	if(isNaN(otp) || otp.length != 4){
		cb && cb({
			data: {
				isSuccess: false
			}
		})
		return;
	}
	axios.post(`/vendor/manage-products-genio/${token}/api/verifyOtp.ns`,{otpValue: otp}).then((data) => {
		cb && cb(data);
	});
};




const AuditEnrichLogin = (props) => {
    let [pageState, updatePageState] = useState('username');
	let [fieldValue, updateFieldValue] = useState('');
	let [buttonLoader, updateButtonLoader] = useState(false);
	let [audiBtnLoader,updateAudiBtnLoader] = useState(false);
	let [showError, updateError] = useState(false);
	let [loggedIn, updateLoggedIn] = useState(false);
    let [input, setInput] = useState('9999999999');
    let [enteredOtp, setEnteredOtp] = useState(null);
   
    let sentOtpUrl = `/vendor/manage-products-genio/${props.session.token}/api/sendOtp.ns?userName=${fieldValue}&isAuditor=${true}&type=${'mobile'}`
    let verifyOtPUrl = `/vendor/manage-products-genio/${props.session.token}/api/verifyOtp.ns`;
    let verifyDataObj = {otpValue: enteredOtp};
    console.log('verifyDataObj',verifyDataObj);
        console.log('verifyOtPUrl',verifyOtPUrl);


	let auditHomePath = "/audit-home";
	if(typeof window !== 'undefined' && window.top != window.self) {
		auditHomePath += '?loadedInIframe=true';
	}
	let history = useHistory();
    const otpText = (input) => {
            return (`We have sent an OTP verification to this number`)    
    }
	useEffect(() => {
		if(window.onfocus) {
			window.onfocus = undefined;
		}
		const host = window.location.host;
		if(auditorDomain.indexOf(host) == -1) {
			if(window.parent && window.parent.location) {
				window.parent.location.href = `${auditorDomain}${window.location.pathname}`;
			} else {
				window.location.href = `${auditorDomain}${window.location.pathname}${window.top != window.self ? "?loadedInIframe=true": '' }`;
			}
		}
	},[]);
	useEffect(() => {
		if(props.session.user.loggedUser && props.session.user.loggedUser.userType == 'AUDITOR'){
			// updateLoggedIn(true);
			// history.push(auditHomePath);
            history.push("/audit-enrich-home");
		}
	},[props.session.user.loggedUser]);


const inputProps = {
	label: 'Enter Tags',
	onUpdate: (data) => {
		// Entered values will be returned in an array in 'data'
	}
};
 	const getCustomHtml = (input) => {
       return(
		`<div>We have sent an OTP verification to this <br/> numbersss</div>`
	) 
}
    const onComplete = (status) => {
		if(status == 'fail'){
            console.log('verification failed');
			setHeader({
				heading: 'Verification Unsuccessful',
				leftIcons: [],
				rightIcons: [{
					className: 'icon-HDRcross',
					onClick: e => {historyHandler.closeCurrent();}
				}],
				variant: 'secondary'
			});
		}else if(status == 'success'){
            console.log('verification successfull');
			history.push("/audit-enrich-home"); //products
		}
	}
    const onSend = (data) => {
		return({
			errors: {
				code: 0
			},
			results:{
				sent: data.isSuccess
			}
		});
	}
    const onVerify = (data) => {
		if(data.isSuccess){
			// props.toggleTab({isToggleTab: true})
			props.setLoggedUser(data.prodCrudData);
		}
		return({
			errors: {
				code: 0
			},
			results:{
				match: data.isSuccess,
				vCodeFailCnt: data.invalidCount
			}
		});
    }

    

  return (
    <div className={'login-page'}>
            <div className = {'holder'}>
                <FormGroup>
					 	<div className={'container'}>
                            <FormLabel className={'heading'}>{pageState == 'username' ? 'Enrichment Audit Module' : 'Enrichment Audit Module'}</FormLabel>
                            <FormLabel className={'sub-heading'}>{pageState == 'username' ? 'Enter Mobile Number To Login' : 'Enter Verification Code'}</FormLabel>
                            {pageState != 'username' ?
                                                <OtpVerification
                                                    className={'topIdle'}
                                                    sendRequest={{url: sentOtpUrl,method: 'GET'}}
                                                    verifyRequest={{'url': verifyOtPUrl,data: verifyDataObj }}
                                                    onVerify={onVerify}
                                                    onComplete={onComplete}   
                                                    onSend={onSend}
                                                    otpLength = {4}
                                                    canChangeInput = {false}
                                                    product={null}
                                                    sendOnMount={false}
                                                    otpKey='otpValue'
                                                    otpFormatter={(val)=>{
                                                                        console.log("val", val);
                                                                        setEnteredOtp(val);
                                                                        return val;}}
                                                    // input={input}
			                                        inputType={'mobile'}
                                                    showCustomHtml = {false}
                                                    handleChange={() => {
                                                        console.log("val");
                                                    }}
                                                    // variant = {'webstore'}
                                                    view={{
                                                        className:'abc',
                                                        icon: 'https://image1.jdomni.in/jdomni_email/014_SmsOtp.svg',
                                                        text: otpText(input),
                                                        codeText: 'Enter Code',
                                                        submitBtnText: 'Submit',
                                                        showSubmit: false,
                                                        correctionText: '',
                                                    }}
                                                    autoRead={false}
                                                    failedCount={4}                                                
                                                                 
                                                    
                                                /> : ""
                            }
                            {pageState == 'username' ? 
                                <div className={'input-box'}>
                                <InputGroup  input={{
                                            placeHolder: 'Mobile No.',
                                            onChange: (e) => {
                                                updateFieldValue(e.target.value);
                                                updateError(false);
                                            }, value: fieldValue}}
                                />
                            </div> : null}
                            { showError ? <div className={'errorMsg'}>
                                <FormFeedBack variant='invalid'>{pageState == 'username' ? 'Invalid Username' : 'Invalid OTP'}</FormFeedBack></div> : null
                            }
                            <div className={'submit-button'}>
                              { pageState == 'username' ? 
                                <Button 
                                    className = {'action-btn'}
                                    showLoader = {buttonLoader}
                                    clickHandler = {() => {
                                        updateButtonLoader(true);
                                        // if(pageState == 'username') {
                                            sendOtp({
                                                updatePageState,
                                                token: props.session.token,
                                                companyName: props.session.companyName,
                                                userName: fieldValue,
                                                cb: (data) => {
                                                    if(data.data.isSuccess) {
                                                        // updateFieldValue('');
                                                        updatePageState('otp');
                                                    } else {
                                                        updateError(true);
                                                    }
                                                    updateButtonLoader(false);
                                                }
                                            });
                                    }}
				                >{pageState == 'username' ? 'Continue' : ''}</Button> : ""

                            }
                                  
                        </div>
                        </div>
                        
                    
					
				</FormGroup>
                
            </div>
    </div>
  )
}

const mapStateToProps = state => {
	return {
		session: state.session,
		auditData: state.products.auditData,
		deviceData: state.deviceData
	};
};

export default connect(mapStateToProps,{setLoggedUser,setAuditObject})(AuditEnrichLogin);


